import React from 'react';

import { Chip } from '@mui/material';

import TENANTS, { TENANT_COLOURS } from '~/consts/tenant';

interface Props {
  tenantValue: string;
}

export default function TenantBrandChip({ tenantValue }: Props) {
  const tenant = TENANTS[tenantValue];
  const colours = TENANT_COLOURS[tenantValue as App.Tenant['value']];
  const label = tenant?.title ?? tenantValue;

  if (!colours) {
    return <Chip size="small" label={label} variant="outlined" />;
  }

  return (
    <Chip
      size="small"
      label={label}
      sx={{
        background: colours.bg,
        color: colours.fg,
        fontWeight: 600,
        border: 0,
      }}
    />
  );
}
